// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2zTwb","header":"ReportDetails_header__2rww4","title":"ReportDetails_title__3a-HY","left":"ReportDetails_left__3Ggax"};